import { Fragment, useCallback } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { CommonQualificationsCrumbs } from 'system/constants/common-qualifications-crumbs';
import OperatorDetail from 'system/components/operators/detail';
import { useParams, useNavigate, generatePath } from 'react-router';

const OperatorDetailPageQualificationsDetail = (): React.ReactElement => {
  const params = useParams();
  const navigate = useNavigate();

  const onCancel = useCallback(() => {
    navigate(generatePath('/sistema/qualifiche/dettaglio/:id', params));
  }, [navigate]);

  return (
    <Fragment>
      <Breadcrumbs
        items={[
          ...CommonQualificationsCrumbs,
          { name: 'Dettaglio Qualifica', path: '/sistema/qualifiche/dettaglio/:id' },
          { name: 'Dettaglio Operatore' },
        ]}
      />
      <OperatorDetail onCancel={onCancel} id={params.idOperatore} />
    </Fragment>
  );
};

OperatorDetailPageQualificationsDetail.displayName =
  'Operator Detail page component from Qualifications detail';

export default OperatorDetailPageQualificationsDetail;
